import changeSavingSubmitionStatus from './events/changeSavingSubmitionStatus';
import saveSubmissionInFillingProcess from './events/saveSubmissionInFillingProcess';

export default {
  saveSubmissionInFillingProcess,
  changeSavingSubmitionStatus,
};
